// @flow
import React, { type Node } from 'react'
import { Box, Cell, Row, Text } from 'sarsaparilla'

type Props = {
    containerProps: {},
    children: Node,
}

export default function AutoSuggestionExitContainer({ containerProps, children }: Props) {
    return (
        <div
            {...containerProps}
            aria-label="suggestion header"
            role="searchbox"
            tabIndex={0}>
            <Box background="gray-2" className="pl-1">
                <Row>
                    <Cell width={7}>
                        <Text fontWeight="semibold">Exit Point Name</Text>
                    </Cell>
                    <Cell width={5}>
                        <Text fontWeight="semibold">Area</Text>
                    </Cell>
                </Row>
            </Box>
            {children}
        </div>
    )
}
